import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {ServerProvider} from "../../providers/server/server";

/**
 * Generated class for the CasePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  name: 'case',
  segment: 'cases/:caseId'
})
@Component({
  selector: 'page-case',
  templateUrl: 'case.html',
})
export class CasePage {
  caseId;
  case;
  notes;
  location;
  statuses = ['Skip', 'No Contact', 'Served', 'Other'];
  loading = true;
  constructor(public server: ServerProvider, public navCtrl: NavController, public navParams: NavParams) {
    this.caseId = this.navParams.get('caseId');
    this.loading = true;
    this.server.get('cases', this.caseId ).subscribe( (data:any)=>{
      console.log('Getting case...', data);
      this.case = data.data;
      this.loading = false;
    });

    this.server.get( 'notes', this.caseId+'/notes' ).subscribe( (data:any)=>{
      console.log( data.data );
      this.notes = data.data;
    });
  }

  status( type ){
    if( this.statuses[type] ) return this.statuses[type];
    else return 'Unknown';
  }
}



// WEBPACK FOOTER //
// ./src/pages/case/case.ts